export default "__VITE_ASSET__BcCk$Nn6__"